import axios from '@/http/axios'

function makeQuery (page = 1, filters = [], sorts = []) {
  let queries = []

  if (page > 1) queries.push(`page=${page}`)

  if (filters.length) queries = queries.concat(...filters)

  if (sorts.length) queries = queries.concat(...sorts)

  return queries
}

export function getBanks (page = 1, filters = [], sorts = []) {
  let queries = makeQuery(page, filters, sorts)

  if (queries.length > 0) queries = `?${  queries.join('&')}`

  return axios({
    url: `v1/admin/banks${queries}`,
    method: 'get'
  })
}
export function getBanksPrice (filters = []) {
  let queries = makeQuery(0, filters)

  if (queries.length > 0) queries = `?${  queries.join('&')}`

  return axios({
    url: `v1/admin/total-banks${queries}`,
    method: 'get'
  })
}

export function getBanksTrash (page = 1, filters = [], sorts = []) {

  let queries = makeQuery(page, filters, sorts)

  queries = queries.length > 0 ? `&${  queries.join('&')}` : ''

  return axios({
    url: `v1/admin/banks?trashed=true${queries}`,
    method: 'get'
  })
}

export function getBank (id) {
  return axios({
    url: `v1/admin/banks/${id}`,
    method: 'get'
  })
}

export function getBankTransactions (id, page = 1, filters = [], sorts = []) {
  let queries = makeQuery(page, filters, sorts)

  if (queries.length > 0) queries = `?${  queries.join('&')}`

  return axios({
    url: `v1/admin/banks/${id}/transactions${queries}`,
    method: 'get'
  })
}

export function printBankTransactions (id, filters = [], sorts = []) {
  let queries = []

  if (filters.length) queries = queries.concat(...filters)

  if (sorts.length) queries = queries.concat(...sorts)

  if (queries.length > 0) queries = `&${  queries.join('&')}`

  return axios({
    url: `v1/admin/banks/${id}/transactions?export=pdf${queries}`,
    method: 'get',
    responseType: 'blob',
  })
}

export function insertBank (payment) {
  return axios({
    url: 'v1/admin/banks',
    data: payment,
    method: 'post'
  })
}

export function editBank (payment) {
  return axios.patch(`v1/admin/banks/${payment.id}`, payment)
}

export function restoreBank (id) {
  return axios({
    url: `v1/admin/banks/${id}/restore`,
    method: 'put'
  })
}

export function deleteBank (id, force = false) {
  return axios({
    url: `v1/admin/banks/${id}${force ? '/force' : ''}`,
    method: 'delete'
  })
}
